// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date[data-v-49dec57b] {\n  -moz-tab-size: 2em;\n    -o-tab-size: 2em;\n       tab-size: 2em;\n}\n", ""]);
// Exports
module.exports = exports;
